import { render, staticRenderFns } from "./modal_editarNorma.vue?vue&type=template&id=2c775835&"
import script from "./modal_editarNorma.vue?vue&type=script&lang=js&"
export * from "./modal_editarNorma.vue?vue&type=script&lang=js&"
import style0 from "./modal_editarNorma.vue?vue&type=style&index=0&id=2c775835&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports